import { Routes, Route, Navigate } from "react-router-dom";
import { Paper, Typography, Grid, Box } from "@mui/material";

import { useAuth } from "@poseidon/ui/components/AuthContext";
import { Login } from "./Login";
import { MicrosoftLogin } from "./MicrosoftLogin";
import { SignUp } from "./SignUp";
import { ForgotPassword } from "./ForgotPassword";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <a style={{ color: "inherit" }} href="https://www.salt-finance.com">
        Salt Finance Ltd.
      </a>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function Layout({ allowRegister = false, microsoftLogin = false }) {
  let auth = useAuth();

  if (auth.user) {
    return <Navigate to="/" replace />;
  }

  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: "url(/login-splash.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Routes>
            <Route
              path="login"
              element={
                microsoftLogin ? (
                  <MicrosoftLogin />
                ) : (
                  <Login allowRegister={allowRegister} />
                )
              }
            />
            {allowRegister && <Route path="signup" element={<SignUp />} />}
            <Route path="forgot-password" element={<ForgotPassword />} />
          </Routes>
          <Copyright sx={{ mt: 5 }} />
        </Box>
      </Grid>
    </Grid>
  );
}
